import React, { LazyExoticComponent, Suspense } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';

import { UserRoleDto } from '@/api/generated';
import { Loader } from '@/components/loader/Loader.comp.tsx';
import { useUserContext } from '@/context/userContext/User.context.ts';
import { RouteEnum } from '@/layouts/routes/model/Route.model.ts';
import { RouteStateModel } from '@/layouts/routes/model/RouteState.model.ts';
import { PATHS_WITHOUT_SESSION } from '@/routes/RoutesNotRequiringAuth.util.ts';
import { isAuthorized } from '@/utils/security/authorization.ts';

interface Props {
  children:
    | LazyExoticComponent<React.FC<{ route: RouteStateModel }>>
    | React.FC<{ route: RouteStateModel }>;
  rolesWithAccess: UserRoleDto[] | undefined;
}

export const RouteGuard: React.FC<Props> = props => {
  const params = useParams();
  const { role } = useUserContext();
  const location = useLocation();
  const route: RouteStateModel = {
    location,
    params,
  };
  const Component = props.children;
  const hasAccessByRole = PATHS_WITHOUT_SESSION || isAuthorized(props.rolesWithAccess ?? [], role);

  if (!hasAccessByRole) {
    return <Navigate replace to={RouteEnum.FORBIDDEN} />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Component route={route} />
    </Suspense>
  );
};
